import { render, staticRenderFns } from "./project-member.vue?vue&type=template&id=f17e1bc2&scoped=true&"
import script from "./project-member.vue?vue&type=script&lang=js&"
export * from "./project-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17e1bc2",
  null
  
)

export default component.exports